import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=3d1b09f6"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d1b09f6')) {
      api.createRecord('3d1b09f6', component.options)
    } else {
      api.reload('3d1b09f6', component.options)
    }
    module.hot.accept("./Projects.vue?vue&type=template&id=3d1b09f6", function () {
      api.rerender('3d1b09f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/projects/Projects.vue"
export default component.exports